import React from 'react'
import ComparisonComponent from '../../components/Comparison/Comparison'

const Comparison = () => {
  return <ComparisonComponent />
}

export default Comparison